import { StyleSheet } from 'aphrodite'

import gui from './gui'

export default {
  gui: StyleSheet.create(gui)
}



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/style/index.js